import React, {ReactElement} from 'react';
import {css, cx} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {FormattedMessage} from 'react-intl';

const styles = {
  container: css`
    label: maintenanceMessage__container;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: ${spacing.XXS};
    border: 1px solid ${colours.border.GRAY};
    border-radius: 5px;
    margin: ${spacing.XS} 0;
    ${mq(Breakpoints.TABLET)} {
      padding: ${spacing.L};
    }
  `,
};

function MaintenanceMessage(): ReactElement {
  return (
    <div className={cx(styles.container)}>
      <h2>
        <FormattedMessage id="maintenanceMessage.title" />
      </h2>
      <p>
        <FormattedMessage id="maintenanceMessage.info" />
      </p>
    </div>
  );
}

export default MaintenanceMessage;
